import React from 'react';
import wb0 from '../img/Detail/waltz_detail.jpg';
import './Detail.css';
const WaltzDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default WaltzDetail;